(function(angular){
	'use strict';
	
	angular
		.module('assetsModule')
		.controller('Assets', [
			'ReitElementFactory',
			AssetsFunction
		]);
	
	function AssetsFunction(
		ReitElementFactory
	){
		var assets = this;

		assets.$onInit = function() {
			ReitElementFactory.getAllReitElements().then(function(reitElementsByStatus) {
				assets.reitElementsByStatus = reitElementsByStatus;
			});
		};
	}
})(window.angular);